export default __webpack_public_path__ + "static/media/maaret-pyhajarvi.22d3d1d9.png";